import { render } from "./NavbarButtons.vue?vue&type=template&id=604de390&scoped=true"
import script from "./NavbarButtons.vue?vue&type=script&lang=js"
export * from "./NavbarButtons.vue?vue&type=script&lang=js"

import "./NavbarButtons.vue?vue&type=style&index=0&id=604de390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604de390"]])

export default __exports__